<nz-week-picker
        [nzAllowClear]="nzAllowClear"
        [nzAutoFocus]="nzAutoFocus"
        [nzDisabled]="nzDisabled"
        [nzDisabledDate]="nzDisabledDate"
        [nzLocale]="nzLocale"
        [nzPopupStyle]="nzPopupStyle"
        [nzDropdownClassName]="nzDropdownClassName"
        [nzSize]="nzSize"


        [nzFormat]="nzFormat"
        [nzPlaceHolder]="nzPlaceHolder"

        [(ngModel)]="value"
        (ngModelChange)="onNgModelChangeChange($event)"
        (nzOnOpenChange)="onNzOnOpenChange($event)"
>

</nz-week-picker>
